import type { SealedOrderPaymentInfo } from '@/payment/types'

import {
  PaymentInfoDivider,
  PaymentInfoMethod,
  PaymentInfoRow,
  PaymentInfoSectionContainer,
  PaymentInfoSectionHeading,
  PaymentInfoSectionInner,
  PaymentMethodLabel,
} from './styles'

interface PaymentInfoSectionProps {
  paymentInfo: SealedOrderPaymentInfo
}

export function PaymentInfoSection({ paymentInfo }: PaymentInfoSectionProps) {
  return (
    <PaymentInfoSectionContainer>
      <PaymentInfoSectionInner>
        <PaymentInfoSectionHeading>결제 정보</PaymentInfoSectionHeading>
        <PaymentInfoDivider />
        <PaymentInfoRow>
          <PaymentMethodLabel>결제수단</PaymentMethodLabel>
          <PaymentInfoMethod>
            {paymentInfo.paymentTypeName} {paymentInfo.alias}
          </PaymentInfoMethod>
        </PaymentInfoRow>
      </PaymentInfoSectionInner>
    </PaymentInfoSectionContainer>
  )
}
